var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-send-count"},[_vm._v(" [SMS로 발송 시 : "+_vm._s(_vm.smsCount)+"건 | 알림톡으로 발송 시 : "+_vm._s(_vm.alimtalkCount)+"건] ")])}
var staticRenderFns = []

export { render, staticRenderFns }